import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

/** Maps an appointment status to badge colors (mirrors the Calls label pills). */
function getStatusColorConfig(status: string): string {
  const s = status.toLowerCase().trim()
  if (['completed', 'done', 'checked in', 'checked-in', 'arrived'].includes(s))
    return 'bg-green-50 text-green-700'
  if (['booked', 'scheduled', 'confirmed'].includes(s))
    return 'bg-blue-50 text-blue-700'
  // Open-slot rows (see openSlotRows) — matches OpenSlotCard's "Open" badge.
  if (s === 'open') return 'bg-green-50 text-green-700'
  if (['pending', 'waiting'].includes(s)) return 'bg-amber-50 text-amber-700'
  if (['rescheduled'].includes(s)) return 'bg-purple-50 text-purple-700'
  if (
    [
      'cancelled',
      'canceled',
      'no-show',
      'no show',
      'noshow',
      'declined',
    ].includes(s)
  )
    return 'bg-red-50 text-red-700'
  return 'bg-gray-100 text-gray-700'
}

/** Colored status pill shared by the Appointments table and detail sheet. */
export function AppointmentStatusBadge({
  status,
}: {
  status: string | null | undefined
}) {
  if (!status) return null
  return (
    <Badge
      className={cn(
        'rounded-md border-transparent capitalize',
        getStatusColorConfig(status)
      )}>
      {status}
    </Badge>
  )
}
